import { getRetailer } from "@faire/retailer-visitor-shared/serialized-data/getRetailer";
import { getUser } from "@faire/retailer-visitor-shared/serialized-data/getUser";
import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";

export const useIsValidRetailer = () => {
  const retailerToken = getRetailer()?.token;
  const user = getUser();

  // Only check for the existence of retailer token is not sufficient because
  // a brand user can also have a retailer token that looks like r_{brandToken}
  const isValidRetailer: boolean =
    !!retailerToken &&
    !!user &&
    !!user.roles &&
    user.roles.indexOf(UserRole.RETAILER) !== -1;

  return { isValidRetailer };
};
